export const IntlPtBr = {

  time: new Intl.DateTimeFormat('pt-BR', {timeStyle: 'short'}),

  date: new Intl.DateTimeFormat('pt-BR', {dateStyle: 'short'}),

  datefull: new Intl.DateTimeFormat('pt-BR', {dateStyle: 'full'}),

  datetime: new Intl.DateTimeFormat('pt-BR', {dateStyle: 'short', timeStyle: 'short'}),

  relativetime: new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' }),

  brl: new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}),

  dec2d: new Intl.NumberFormat('pt-BR', {maximumFractionDigits: 2}),

  dec4d: new Intl.NumberFormat('pt-BR', {maximumFractionDigits: 4})

};